var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEngineOperation = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.51,
    height: 27,
    viewBox: "0 0 33.51 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3559 -13488.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3559 13496.55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.488,107.515a.92.92,0,0,0-.92.92v1.832H27.3V107.2a.92.92,0,0,0-.92-.92H22.99l-3.749-2.653a.92.92,0,0,0-.532-.169H16.624v-1.871h1.564a.92.92,0,1,0,0-1.84H13.22a.92.92,0,1,0,0,1.84h1.564v1.871H12.7a.92.92,0,0,0-.532.169L8.418,106.28H5.03a.92.92,0,0,0-.92.92v3.067H1.84v-1.832a.92.92,0,0,0-1.84,0v5.5a.92.92,0,1,0,1.84,0v-1.832H4.11v3.067a.92.92,0,0,0,.92.92h2.76V118a.92.92,0,0,0,.92.92H26.378a.92.92,0,0,0,.92-.92v-5.889h2.27v1.832a.92.92,0,1,0,1.84,0v-5.5A.92.92,0,0,0,30.488,107.515Zm-5.03,9.561H9.631v-1.9a.92.92,0,0,0-.92-.92H5.95V108.12h2.76a.92.92,0,0,0,.532-.169l3.749-2.653h5.426l3.749,2.653a.92.92,0,0,0,.532.169h2.76v8.956Z",
    transform: "translate(0 -99.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.334,236.948h-2.2l1.067-1.067a.92.92,0,0,0-1.3-1.3l-2.638,2.638a.92.92,0,0,0,.651,1.571h2.2l-1.922,1.922a.92.92,0,1,0,1.3,1.3l3.493-3.493a.92.92,0,0,0-.651-1.571Z",
    transform: "translate(-192.422 -226.056)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3538.054 13488.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.982,3.7a6.282,6.282,0,1,0,6.282,6.282A6.289,6.289,0,0,0,9.982,3.7Zm0,10.987a4.706,4.706,0,1,1,4.706-4.706A4.711,4.711,0,0,1,9.982,14.687Z",
    transform: "translate(-3.7 -3.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.788,93.054l-1.2-.6a1.177,1.177,0,0,0-.331-.533V89.389a.789.789,0,1,0-1.578,0v2.525a1.161,1.161,0,0,0,.787,2.017,1.123,1.123,0,0,0,.411-.077l1.205.607a.8.8,0,0,0,.354.085.788.788,0,0,0,.356-1.491Z",
    transform: "translate(-204.181 -86.486)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M228.2,383a.7.7,0,1,0,.7.7A.706.706,0,0,0,228.2,383Z",
    transform: "translate(-221.928 -373.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.9,227.8a.7.7,0,1,0,.7.7A.706.706,0,0,0,72.9,227.8Z",
    transform: "translate(-70.495 -222.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M383.3,227.9a.7.7,0,1,0,.7.7A.706.706,0,0,0,383.3,227.9Z",
    transform: "translate(-373.167 -222.318)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEngineOperation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/engine-operation.dda72056.svg";
export { ForwardRef as ReactComponent };